import React from "react";
import { ModuleWrapper } from "./Module.style";

const Module = ({ src, title, text, nonfixed }) => {
  
  return (
    <>
      <ModuleWrapper nonfixed={nonfixed}>
        <div className="fitter">
        <a href={src} target={nonfixed?"":"_blank"}>
          <a href={src} target={nonfixed?"":"_blank"} className="atitle">
            {title}
          </a>
          <div className="bosluk"></div>
          {typeof text == "object" ? (
            text.map((item) => (
              <p key={Math.random()*1000}>
                <span>&bull;</span>
                {item}
              </p>
            ))
          ) : (
            <p>
              <span>&bull;</span>
              {text}
            </p>
          )}
        </a>
        </div>
      </ModuleWrapper>
    </>
  );
};

export default Module;
